import Service from './Service';
import { getAuthToken } from 'state';

const apiURL = process.env.REACT_APP_INQUIRY_DISPUTE_API ?? '';
const apiKey = process.env.REACT_APP_CRM_KEY ?? '';

export default class ApiService extends Service {
    constructor() {
        const token = getAuthToken();
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key': apiKey
        }
        super(apiURL, headers);
    }
}